export default __webpack_public_path__ + "static/media/AD.8c49bd73.png";